import type { JSX } from 'react';
import { Navigate, Route, BrowserRouter, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { RequireAuth } from '@/auth/require-auth.tsx';
import { authService } from '@/services/auth.service.ts';
import { AuthCallbackScreen } from '@/screens/auth-callback/auth-callback.screen.tsx';
import { HomeScreen } from '@/screens/home/home.screen.tsx';
import { LoginScreen } from '@/screens/login/login.screen.tsx';
import { NotFoundScreen } from '@/screens/not-found/not-found.screen.tsx';

function RootRedirect(): JSX.Element {
  return authService.isAuthenticated() ? (
    <Navigate to="/app" replace />
  ) : (
    <Navigate to="/login" replace />
  );
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/auth/callback" element={<AuthCallbackScreen />} />
          <Route element={<RequireAuth />}>
            <Route path="/app" element={<HomeScreen />} />
          </Route>
          <Route path="*" element={<NotFoundScreen />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
